import { Action } from '@ngrx/store';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';

export const SET_SELECTED_CUSTOMER = 'select-customer:SET_SELECTED_CUSTOMER';
export const CLEAR_SELECTED_CUSTOMER = 'select-customer:CLEAR_SELECTED_CUSTOMER';

export class SetSelectedCustomerAction implements Action {
  readonly type = SET_SELECTED_CUSTOMER;
  logPayload = true;

  constructor(readonly payload: { customer: Customer }) {}
}

export class ClearSelectedCustomerAction implements Action {
  readonly type = CLEAR_SELECTED_CUSTOMER;
}

export type Actions = SetSelectedCustomerAction | ClearSelectedCustomerAction;
